module.exports = __webpack_public_path__ + "static/media/wonkyTongue.7e5d2d8a.jpg";